/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import {
  REMOVE_CONTAINER_ITEM,
  ADD_CONTAINER_ITEM,
  UPDATE_CONTAINER_ITEM,
  REPLACE_CONTAINER_ITEM,
  UPDATE_TRANSIENT_DATA,
  REPLACE_TRANSIENT_DATA
} from '../actions';
import { removeFormFieldsFromMap } from '../../../utils/form-handler';
import ContextTreeManager from '../../../contextree/treemanager';

/**
 * Redux middleware to track the redux changes
 * and manipulate the FormFieldsMap object
 * of Form Handler
 */

const validationMiddleware = () => (next: any) => (action: any) => {
  const { type = '', payload = {} } = action || {};
  const { category, context, transientItemID } = payload;

  if (
    category !== 'HTTP' &&
    [
      ADD_CONTAINER_ITEM,
      UPDATE_CONTAINER_ITEM,
      REMOVE_CONTAINER_ITEM,
      REPLACE_CONTAINER_ITEM,
      UPDATE_TRANSIENT_DATA,
      REPLACE_TRANSIENT_DATA
    ].includes(type)
  ) {
    removeFormFieldsFromMap(context || transientItemID);
    ContextTreeManager.removeContextTreeNode(context || transientItemID);
  }
  next(action);
};

export default validationMiddleware;
